module.exports = __webpack_public_path__ + "static/media/footui_7.d0de98c9.gif";